export default __webpack_public_path__ + "static/popup-img-57e0e231688ee517bdebdb8a6b4622d5.jpg";